import React from 'react';
import { t } from '@lingui/core/macro';
import { DateRangePicker } from '@ygtechnologies/bygr-frontend-component-library';
import { parseNullableISODate } from '@ygtechnologies/rubus-frontend-utilities';

interface FilterDateProps {
    open: boolean;
    startDate: Date | string | null;
    endDate: Date | string | null;
    setOpen: (open: boolean) => void;
    onChange: (startDate: Date | null, endDate: Date | null) => void;
}

export const FilterDate = ({ startDate, endDate, onChange }: FilterDateProps) => {
    return (
        <DateRangePicker
            startDate={parseNullableISODate(startDate)}
            endDate={parseNullableISODate(endDate)}
            onChange={onChange}
            placeholderStart={t`from`}
            placeholderEnd={t`to`}
            direction="vertical"
            inputClassName="form-control"
            clearable
        />
    );
};
